import Image from 'next/image';
import { SubCategoryImage } from './styled';

export default function SubCategoryBanner(props) {
  const { heading, image, bannerId, index } = props;
  return (
    <>
      {/* <SubCategoryHeader>{heading?.toLowerCase()}</SubCategoryHeader> */}
      {image ? (
        <SubCategoryImage>
          <Image
            src={image}
            alt={heading}
            quality={100}
            loading={index === 0 ? 'eager' : 'lazy'}
            priority={index === 0 ? true : false}
            fill
            sizes="100vw"
          />
        </SubCategoryImage>
      ) : null}
    </>
  );
}
